import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedLiabilityInsuranceDocument,
  AddLiabilityInsuranceMutation,
  AddLiabilityInsuranceMutationVariables,
  AddLiabilityInsuranceDocument,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { resetPaginationField } from "@/store/paginationStore";

/**
 * Custom hook for creating a liability insurance and handling the necessary cache updates.
 * @returns {Object} - Contains the createLiabilityInsuranceMutation function, loading state, and error state.
 */
export default function useAddLiabilityInsuranceMutationHook(): { addLiabilityInsuranceMutation: any, loading: any, error: any } {
  const { t } = useTranslation(["toasts"]);

  const [addLiabilityInsuranceMutation, { loading, error }] = useMutation<AddLiabilityInsuranceMutation, AddLiabilityInsuranceMutationVariables>(
    AddLiabilityInsuranceDocument, {
      onCompleted: () => {
        // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedLiabilityInsurance");

        toast(CustomToastComponent, {
          toastId: "liability-insurance-added-success",
          data: {
            title: t("toasts.liabilityinsuranceaddedsuccessfully"),
            type: "success"
          }
        });
      },
      refetchQueries: [
        {
          query: PaginatedLiabilityInsuranceDocument,
          variables: {
            first: 10,
            after: null,
            currentPage: 0,
            filters: {
              activeFrom: null,
              liabilityInsurance: null,
              professionalAssociation: null
            },
            sort: null
          }
        }
      ]
    });

  return {
    addLiabilityInsuranceMutation,
    loading,
    error
  };
}
